import React, { Component } from 'react';
import * as api from '../api/api';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Card } from 'rmwc/Card';
import CertificationDetail from './CertificationDetail';
import StatusMessage from '../util/StatusMessage'

class Certifications extends Component{

  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      loading: false,
      data:{
        'tpoAchievements': [],
        'mcAchievements': [],
        'fcAchievements': [],
        'miebAchievements': [],
        'tqAchievements': [],
        'mqUserReportLinks': [],
        'fcUserReportLinks': []
      },
    };
  
    this.fetchReport = this.fetchReport.bind(this)
    this.setLoadingState = this.setLoadingState.bind(this)
  }

  componentDidMount() {

    return

    let data = Object.assign({}, this.state.data)
    let tpoAchievements
    return api.tpoAchievements(this.props.user.accessToken)
      .then((result) => {
        data.tpoAchievements = result.tpo
    return api.mcAchievements(this.props.user.accessToken)
    }).then((result) => {
        data.mcAchievements = result.mc    
    return api.fcAchievements(this.props.user.accessToken)
    }).then((result) => {
        data.fcAchievements = result.fc     
    return api.miebAchievements(this.props.user.accessToken)    
    }).then((result) => {
        data.miebAchievements = result.mieb
        return api.tqAchievements(this.props.user.accessToken)
    }).then((result) => {
        data.tqAchievements = result.tq
        return api.mcUserReportLink(this.props.user.accessToken)
    }).then((result) => {
        data.mqUserReportLinks = result.mc
        return api.fcUserReportLink(this.props.user.accessToken)
    }).then((result) => {
        data.fcUserReportLinks = result.fc
        this.setState({data: data})
    })
  }

  fetchReport(event) {
    
    api.getTPOReport(this.props.user.accessToken)
      .then((result) => {
            
      })
    
  }

  setLoadingState(stateValue, errorMsg){
    this.setState({ loading: stateValue, errorMsg: errorMsg})
  }

  fetchMiebReport = (e, mieb_cert_id) => {
    this.setLoadingState(true)
    api.downloadMIEBReport(this.props.user.accessToken, mieb_cert_id)
      .then((result) => {
         if (result instanceof Blob){
          this.setState({ errorMsg: '' })
          this.setLoadingState(false, '')
          const url = window.URL.createObjectURL(result);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'miebreport.pdf');
          document.body.appendChild(link);
          link.click();
        }
        else{
          this.setState({ errorMsg: 'Unable to download reports. Please contact Administrator' })
          this.setLoadingState(false, 'Unable to download reports. Please contact Administrator')
        }      
      }).catch((err) => {
          this.setState({ errorMsg: 'Unable to downlod reports. Plaase contact Admin' })
          this.setLoadingState(false, 'Unable to download reports. Please contact Admin')
      })
  }
  

  render() {
    let loadingStateFn = this.setLoadingState
    let tpoDetail = <div> {this.state.data.tpoAchievements.map(tpoAchievement => (
              <CertificationDetail tpoAchievement={tpoAchievement} accessToken={this.props.user.accessToken} onLoadingState={loadingStateFn}/>
            ))} </div>

    let miebAchieveContent

    let fetchMiebReportFn = this.fetchMiebReport

    if(this.state.data.miebAchievements.length > 0){
      miebAchieveContent = (
        <div>
          <br/>
            <Typography use="headline6">MIEB Performance Report</Typography>
            <table>
              <thead>
                <tr>
                  <th>Download Link</th> 
                </tr>
              </thead>
              <tbody>
                {this.state.data.miebAchievements.map(miebAchievement => (
                <tr>
                  <td>
                    <Button outlined className="button-link" onClick={((e) => fetchMiebReportFn(e, miebAchievement.id))}>Download</Button>
                  </td>
                </tr>
                ))}
              </tbody>
            </table>  
        </div>    
        )
    }

    let tqAchieveContent
    if(this.state.data.tqAchievements.length > 0){
      tqAchieveContent = (
        <div>
          <br/>
            <Typography use="headline6">TQ Performance Report</Typography>
            <table>
              <thead>
                <tr>
                  <th>Download Link</th> 
                </tr>
              </thead>
              <tbody>
                {this.state.data.tqAchievements.map(tqAchievement => (
                <tr>
                  <td>
                    <a href={tqAchievement.report_link} target="_blank"> TQ Report</a>

                  </td>
                </tr>
                ))}
              </tbody>
            </table>  
        </div>    
        )
    }


    let mcUserReportLinkContent
    if(this.state.data.mqUserReportLinks.length > 0){
      mcUserReportLinkContent = (
        <div>
          <br/>
            <Typography use="headline6">Micro-Credentials Performance Report</Typography>
            <table>
              <thead>
                <tr>
                  <th></th> 
                  <th>Report</th> 
                </tr>
              </thead>
              <tbody>
                {this.state.data.mqUserReportLinks.map(mcUserReportLink => (
                <tr>
                  <td>
                    {mcUserReportLink.mc_topic_name}
                  </td>
                  <td>
                    <a href={mcUserReportLink.report_link} target="_blank">Download</a>
                  </td>
                </tr>
                ))}
              </tbody>
            </table>  
        </div>    
        )
    }

    let fcUserReportLinkContent
    if(this.state.data.fcUserReportLinks.length > 0){
      fcUserReportLinkContent = (
        <div>
          <br/>
            <Typography use="headline6">CENTA Certification Performance Report</Typography>
            <table>
              <thead>
                <tr>                   
                  <th>Download Link</th> 
                </tr>
              </thead>
              <tbody>
                {this.state.data.fcUserReportLinks.map(fcUserReportLink => (
                <tr>
                  
                  <td>
                    <a href={fcUserReportLink.report_link} target="_blank">Download</a>
                  </td>
                </tr>
                ))}
              </tbody>
            </table>  
        </div>    
        )
    }

    let content

    if(!this.state.loading){
       content = <div class="mdc-layout-grid">
          <div class="mdc-layout-grid__inner"> 
            <div class="mdc-layout-grid__cell--span-10">
              <Card style={{padding: '0px'}}>
              <Typography use="headline5">Performance Reports</Typography>
              </Card>
              <br/>
              <Typography use="content"> Performance Reports for assessments undertaken by you (if any) are displayed here.</Typography>
              <StatusMessage error_msg = {this.state.errorMsg}/>
              {tpoDetail}
              {miebAchieveContent}
              {tqAchieveContent}
              {mcUserReportLinkContent}
              {fcUserReportLinkContent}
              <div hidden>
                <br/>
                <Typography use="headline6">Certification</Typography>
                <table>
                  <thead>
                    <tr>
                      <th>Roll No.</th>
                      <th>Test Track</th>
                      <th>Achievement, if any</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.data.fcAchievements.map(fcAchievement => (
                        <tr>
                          <td>{fcAchievement.roll_number}</td>
                          <td>{fcAchievement.test_track_name}</td>
                          <td>{fcAchievement.achievement}</td>
                        </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div hidden>
                <br/>
                <Typography use="headline6">Micro-Credential</Typography>
                <table>
                  <thead>
                    <tr>
                      <th>Test Track</th>
                      <tr>
                        <th width="250px">Roll No.</th>
                        <th width="250px">Micro Credentail</th>
                        <th width="250px">Achievement, if any</th>
                      </tr>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.data.mcAchievements.map(mcAchievement => (
                        <tr>
                          <td rowspan={mcAchievement.micro_credentials_topic.size}>{mcAchievement.test_track_name}</td>
                          {mcAchievement.micro_credentials_topic.map(topic => (
                            <tr>
                              <td width="250px">{topic.roll_number}</td>
                              <td width="250px">{topic.mc_topic_name}</td>
                              <td width="250px">{topic.achievement}</td>
                            </tr>
                          ))}
                        </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              
            <div class="mdc-layout-grid__cell--span-1"></div>
            <div class="mdc-layout-grid__cell--span-1"></div>
          </div>
        </div>
      </div>
    }
    else{
      content = (
          <div className="loader-component">
            <div className="loader"></div>
            <h4> Report is being generated. Please wait</h4>
          </div>
        )
    }

    return (
        <div>
          {content}
        </div>
      )
    }
  
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Certifications);



// WEBPACK FOOTER //
// ./src/views/Certifications.jsx